import { Controller } from "@hotwired/stimulus"
import '../sources/nested_form';

export default class extends Controller {
  static targets = ["cell"]
  static values = {
  }
  // Called when the controller connects to the DOM
  connect() {
    // Code here runs when the page loads
    this.grilleInstances = []

    this.set_grilleligne_target();
    this.set_key_shortcuts();
    this.bind_close_assistant();

    this.initializeGrilles();
    this.setupObserver();
  }

  disconnect() {
    this.grilleInstances = []

    if (this.observer) {
      this.observer.disconnect()
    }    
  } 

  // Functions you want available for direct call
  initializeGrilles() {
    this.cellTargets.forEach(element => {
        this.initializeGrilleCell(element)
    })
  }

  initializeGrilleCell(element){
    if (this.isElementInitialized(element)) {return;}

    function select_grille_cell(event) {
        const $element = $(event.srcElement)
        if($(event.srcElement).hasClass("selected-cell")){ return;}
        $(".grille_cell").removeClass("selected-cell");
        $element.addClass("selected-cell");
    };

    function open_facture(event) {
        const $element = $(event.srcElement)
        if(!$element.hasClass("selected-cell") || event.which != 27){return;}
        else{
            let type_facture = $('#rfp_grille').attr('class');
            let id_facture = $('.selected-cell').attr('id').split("-").pop();
            let url = '/rfp/' + type_facture + '_factures/' + id_facture
            let win = window.open(url, '_blank');
            win.focus();
        }
    };    

    element.addEventListener('click', select_grille_cell);
    element.addEventListener('keydown', open_facture);
    // Store the instance and configuration for later reference
    this.grilleInstances.push({ element: element})      
  }  

  isElementInitialized(element) {
    // Check if the element is already in the instances array
    return this.grilleInstances.some(instance => 
      instance.element === element
    )
  }    

  setupObserver() {
    // Create a new MutationObserver
    this.observer = new MutationObserver(mutations => {
      let needsInitialization = false
      
      // Check if any mutations added nodes to the DOM
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          needsInitialization = true
          break
        }
      }

      if (needsInitialization) {
        this.initializeGrilles()
      }
    })
    // Start observing the entire element that contains this controller
    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })
  }

  set_grilleligne_target(){
    // Place au bon endroit la nouvelle ligne de la grille a l ajout
    window.NestedFormEvents.prototype.insertFields = function(content, assoc, link) {
        if(assoc.match(/grille/)) {
        var $tr = $(link).closest('tr');
        return $(content).insertBefore($tr);
        }
        var target = $(link).data('target');
        if (target) {
        return $(content).appendTo($(target));
        } else {
        return $(content).insertBefore(link);
        }
    }
  }

  set_key_shortcuts(){
    // Ajout d'une ligne avec insertion
    $(document).keydown(function(e) {
        if(e.which == 45 ) {
        $("a.grille_lignes_fields_blueprint").click();
        $(".attr-personne").hide(200)
        $(".icon-plus-personne").removeClass('fa-minus').addClass('fa-plus');
        $('.datepicker').hide();
        setTimeout(function() {
          $('.personnes_affichage .selectize-input input').last().focus();
        }, 50);

        //$('.personnes_affichage .selectize-input input').last().focus();
        }
        if(e.which == 38 && document.activeElement.className.includes("grille_cell") ) {
        if ($('.grille-container') && $('.selected-cell')){
            var cell_id = $('.selected-cell').get(0).id;
            var new_selected_cell = $('#' + cell_id).closest('.fields').prev().find("[id$='-" + cell_id .split("-")[4] + "']").find("input.grille_cell");
            if (new_selected_cell.get(0)) {
            $('#' + cell_id).removeClass("selected-cell");
            new_selected_cell.addClass("selected-cell").focus();
            }
        }
        }
        if(e.which == 40 && document.activeElement.className.includes("grille_cell") ) {
        if ($('.grille-container') && $('.selected-cell')){
            var cell_id = $('.selected-cell').get(0).id
            var new_selected_cell = $('#' + cell_id).closest('.fields').next().find("[id$='-" + cell_id .split("-")[4] + "']").find("input.grille_cell");
            if (new_selected_cell.get(0)) {
            $('#' + cell_id).removeClass("selected-cell");
            new_selected_cell.addClass("selected-cell").focus();
            }
        }
        }
        if(e.which==37 && e.ctrlKey && document.activeElement.className.includes("grille_cell") ) {
        if ($('.grille-container') && $('.selected-cell')){
            var cell_id = $('.selected-cell').get(0).id
            var new_selected_cell = $('#' + cell_id).closest('.td-grille').prev().find("input.grille_cell")
            if (new_selected_cell.get(0)) {
            $('#' + cell_id).removeClass("selected-cell");
            new_selected_cell.addClass("selected-cell").focus();
            }
        }
        }
        if(e.which==39 && e.ctrlKey && document.activeElement.className.includes("grille_cell") ) {
        if ($('.grille-container') && $('.selected-cell')){
            var cell_id = $('.selected-cell').get(0).id
            var new_selected_cell = $('#' + cell_id).closest('.td-grille').next().find("input.grille_cell");
            if (new_selected_cell.get(0)) {
            $('#' + cell_id).removeClass("selected-cell");
            new_selected_cell.addClass("selected-cell").focus();
            }
        }
        }
    
    });
  }

  extract_nam(event){
    var text = $('textarea#liste_patients').val();
    var nams = text.replace(/[\n\r]/g,'').match(/[a-zA-z]{4}\s?[0-9]{4}\s?[0-9]{4}\s?/g);
    var validRegex = /[A-Za-z]{4}\d{2}(0[1-9]|1[0-2]|5[1-9]|6[0-2])(0[1-9]|[12]\d|3[01])\d{2}/;
    
    var processed = nams.map(n => {
      var clean = n.replace(/ /g,'').toUpperCase();
      return validRegex.test(clean) ? clean : clean + " - ?";
    });
    $('textarea#liste_patients').val(processed.join(',\n'));
  }

  nettoyer(event) {
    var text = $('textarea#grille').val();  
    
    var cleaned_text = text
      .split('\n')
      // 1. Retirer tout ce qui est après le premier |
      .map(line => line.split('|')[0].trim())
      // 2. Filtrer : exclure les lignes qui commencent par # ou -, ET les lignes vides
      .filter(line => line.length > 0 && !line.match(/^[#-]/))
      .join('\n');

    $('textarea#grille').val(cleaned_text);
  }

  bind_close_assistant(){
    $("#grille-assistant").on("dblclick", function(){
        $(this).hide(200);
    });
  }  
}
